import React from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Button,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaletteIcon from '@mui/icons-material/Palette';
import InventoryIcon from '@mui/icons-material/Inventory2';
import PsychologyIcon from '@mui/icons-material/Psychology';
import EventIcon from '@mui/icons-material/Event';
import CodeIcon from '@mui/icons-material/Code';
import { setToken } from './api';

const DRAWER_WIDTH = 240;

const links = [
  { to: '/admin', label: 'Dashboard', icon: <DashboardIcon />, end: true },
  { to: '/admin/impostazioni', label: 'Branding', icon: <PaletteIcon /> },
  { to: '/admin/prodotti', label: 'Prodotti', icon: <InventoryIcon /> },
  { to: '/admin/prompt', label: 'Prompt AI', icon: <PsychologyIcon /> },
  { to: '/admin/appuntamenti', label: 'Contatti', icon: <EventIcon /> },
  { to: '/admin/embed', label: 'Codice embed', icon: <CodeIcon /> },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    setToken(null);
    navigate('/admin/login');
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' },
        }}
      >
        <Toolbar>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Gestionale
          </Typography>
        </Toolbar>
        <List>
          {links.map((link) => (
            <ListItemButton
              key={link.to}
              component={NavLink}
              to={link.to}
              end={link.end}
              sx={{
                '&.active': { bgcolor: 'action.selected' },
              }}
            >
              <ListItemIcon>{link.icon}</ListItemIcon>
              <ListItemText primary={link.label} />
            </ListItemButton>
          ))}
        </List>
        <Box sx={{ mt: 'auto', p: 2 }}>
          <Button fullWidth variant="outlined" onClick={logout}>
            Esci
          </Button>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: 'grey.50' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
